var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoLockerBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "5k2fqry9ga"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.662745 0 0 0 0 0.992157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: ""
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 1.5)",
    stroke: "#0196e0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    y: 7.778,
    width: 15.556,
    height: 13.222,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.889 7.316V4.444C11.889 1.99 9.974 0 7.61 0 5.25 0 3.333 1.99 3.333 4.444v2.872"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.407,
    cy: 12.481,
    r: 1.852
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M7.593 14.519v3.333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoLockerBlue);
export default __webpack_public_path__ + "static/media/PictoLockerBlue.3c30cbf656e5b6668ae9eb82825ecf1c.svg";
export { ForwardRef as ReactComponent };